import ApiService from "@/utils/api.service";

export default {

    list(context) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("moneyRequest")
                .then(({ data }) => {
                    context.commit("setList", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    update(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("moneyRequest/" + params.id, { status: params.status }).
                then(({ data }) => {
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        })
    },
    get(context, moneyRequestId) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.get("moneyRequest/" + moneyRequestId)
                .then(({ data }) => {
                    context.commit("setRequest", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },

}